/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";
import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";

import { RootState } from "store/types";
import ManagerDashboardView from "./ManagerDashboardView";
import { LocationCategory } from "./ManagerDashboardView/types";
import QuotaDashboardErrorView from "./QuotaDashboardErrorView";

interface QuotaDashboardUrlParams {
  category?: string;
  idHash?: string;
}

export default function QuotaDashboardRoute({
  match,
}: RouteComponentProps<QuotaDashboardUrlParams>) {
  const orgId = useSelector(
    (state: RootState) => state.selfObject.organizationId
  );
  const selfObject = useSelector((state: RootState) => state.selfObject);

  const { locationCategory, locationId } =
    match.params.category && match.params.idHash
      ? {
          locationCategory: match.params.category,
          locationId: match.params.idHash,
        }
      : {
          locationCategory: "organization",
          locationId: orgId,
        };

  return (
    <View
      style={{
        flexDirection: "column",
        alignItems: "center",
        margin: 24,
      }}
    >
      <View
        style={{
          maxWidth: 1200,
          flexDirection: "column",
          alignItems: "stretch",
          width: "100%",
        }}
      >
        {!selfObject.organizationManagerDashboardEnabled ? (
          <QuotaDashboardErrorView
            message={"This organization does not support the manager dashboard"}
          />
        ) : !selfObject.isManager ? (
          <QuotaDashboardErrorView
            message={
              "You don't have access to the manager dashboard for this organization"
            }
          />
        ) : (
          <ManagerDashboardView
            locationType={
              locationCategory as LocationCategory /* TODO add some validation to make sure this is a valid category string */
            }
            locationId={locationId}
          />
        )}
      </View>
    </View>
  );
}
